module.exports = __webpack_public_path__ + "img/step_12.4afc940c.webp";